import { render, staticRenderFns } from "./DistributionDialog.vue?vue&type=template&id=0cab2715&scoped=true"
import script from "./DistributionDialog.vue?vue&type=script&lang=ts"
export * from "./DistributionDialog.vue?vue&type=script&lang=ts"
import style0 from "./DistributionDialog.vue?vue&type=style&index=0&id=0cab2715&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cab2715",
  null
  
)

export default component.exports